import {AccountPermission} from '../components/account-permissions';
import {AccountType} from '../enums/account-type';
import {Exchange, EXCHANGE_NAMING, EXCHANGES_ALLOWED_IN_ACCOUNT} from '../enums/exchange';
import {ExchangeAccountStatus} from '../enums/exchange-account-status';

export const DEFAULT_EXCHANGE = EXCHANGES_ALLOWED_IN_ACCOUNT.includes(Exchange.BINANCE)
    ? Exchange.BINANCE
    : EXCHANGES_ALLOWED_IN_ACCOUNT[0];

export const DEFAULT_ACCOUNT_TYPE = AccountType.CASH;
const DEFAULT_ACCOUNT_TYPE_BY_EXCHANGE: Partial<Record<Exchange, AccountType>> = {
    [Exchange.BITMEX]:     AccountType.MARGIN,
    [Exchange.KRAKEN_FUT]: AccountType.MARGIN
};
export const getDefaultAccountTypeByExchange = (exchange: Exchange): AccountType =>
    DEFAULT_ACCOUNT_TYPE_BY_EXCHANGE[exchange] || DEFAULT_ACCOUNT_TYPE;

/**
 * Exchange Account Base.
 */
export interface ExchangeAccountBase {
    id: number;
    type: AccountType;
}

/**
 * Exchange Account Base.
 */
export interface ExchangeAccountBaseWithLeverage extends ExchangeAccountBase {
    leverage?: number;
}

/**
 * ExchangeAccount.
 */
export interface ExchangeAccount extends ExchangeAccountBase {
    displayName: string;
    exchange: Exchange;
    privateKey: string;
    publicKey: string;
    apiPassword: string;
    subAccountName: string;
    active: boolean;
    status: ExchangeAccountStatus;
    permission: AccountPermission;
    companyId?: number;
    companyName?: string;
    userId?: number; // It's optional, since it's used rarely.
}

/**
 * Exchange Account ID.
 */
export type ExchangeAccountId = ExchangeAccount['id'];

export const NEW_EXCHANGE_ACCOUNT: ExchangeAccount = {
    id:             null,
    exchange:       DEFAULT_EXCHANGE,
    displayName:    EXCHANGE_NAMING[DEFAULT_EXCHANGE] || DEFAULT_EXCHANGE,
    privateKey:     null,
    publicKey:      null,
    apiPassword:    null,
    subAccountName: null,
    active:         true,
    status:         ExchangeAccountStatus.ACTIVE,
    type:           getDefaultAccountTypeByExchange(DEFAULT_EXCHANGE),
    permission:     AccountPermission.WRITE
};

export function isExchangeAccountBaseEqual(
    accountBase: ExchangeAccountBase,
    otherAccountBase: ExchangeAccountBase
): boolean {
    return (accountBase === otherAccountBase)
        || (!accountBase && !otherAccountBase)
        || (accountBase && otherAccountBase
            && accountBase.id === otherAccountBase.id
            && accountBase.type === otherAccountBase.type);
}
